<template>
  <v-dialog :model-value="modelValue" persistent max-width="720"
            @update:model-value="$emit('update:modelValue', $event)">
    <v-card>
      <v-card-title>Choix de la situation d'exercice</v-card-title>
      <v-card-text>
        <v-list density="compact" class="liste-situations">
          <v-list-item v-for="(s, i) in situations" :key="i"
                       :active="i === indexSel" @click="indexSel = i"
                       @dblclick="valider">
            <v-list-item-title>{{ libelle(s) }}</v-list-item-title>
          </v-list-item>
        </v-list>

        <v-divider class="my-2" />

        <div v-if="situationActive" class="detail-situation">
          <div><strong>Nom :</strong> {{ nomPorteur }}</div>
          <div><strong>Mode d'exercice :</strong> {{ c(situationActive, CPS_MODE_EXERCICE) }}</div>
          <div><strong>Statut d'exercice :</strong> {{ c(situationActive, CPS_STATUT_EXERCICE) }}</div>
          <div><strong>Structure :</strong> {{ c(situationActive, CPS_IDENT_STRUCTURE) }} — {{ c(situationActive, CPS_RAISON_SOCIALE_STRUCTURE) }}</div>
          <div><strong>Ident. facturation :</strong> {{ c(situationActive, CPS_IDENT_FACTURATION) }}</div>
          <div><strong>Convention :</strong> {{ c(situationActive, CPS_CODE_CONVENTION) }}</div>
          <div><strong>Specialite :</strong> {{ c(situationActive, CPS_CODE_SPECIALITE) }}</div>
          <div><strong>Zone tarifaire :</strong> {{ c(situationActive, CPS_ZONE_TARIFAIRE) }}</div>
          <div><strong>Zone IK :</strong> {{ c(situationActive, CPS_ZONE_IK) }}</div>
          <div><strong>Habilitation FSE :</strong> {{ c(situationActive, CPS_HABILITATION_FSE) }}</div>
          <div><strong>Habilitation lot :</strong> {{ c(situationActive, CPS_HABILITATION_LOT) }}</div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="annuler">Annuler</v-btn>
        <v-btn color="primary" :disabled="indexSel < 0" @click="valider">Valider</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
    listeSituations, porteur, champ, libelleSituation,
    CPS_NOM, CPS_MODE_EXERCICE, CPS_STATUT_EXERCICE, CPS_IDENT_STRUCTURE,
    CPS_RAISON_SOCIALE_STRUCTURE, CPS_IDENT_FACTURATION, CPS_CODE_CONVENTION,
    CPS_CODE_SPECIALITE, CPS_ZONE_TARIFAIRE, CPS_ZONE_IK,
    CPS_HABILITATION_FSE, CPS_HABILITATION_LOT,
} from '@/script/champsCPS';

export default {
    name: 'DialogSituationCPS',
    props: {
        modelValue: { type: Boolean, default: false },
        cps: { type: [Array, Object], default: null },
    },
    emits: ['update:modelValue', 'choisir', 'annuler'],
    data() {
        return {
            indexSel: 0,
            CPS_MODE_EXERCICE, CPS_STATUT_EXERCICE, CPS_IDENT_STRUCTURE,
            CPS_RAISON_SOCIALE_STRUCTURE, CPS_IDENT_FACTURATION, CPS_CODE_CONVENTION,
            CPS_CODE_SPECIALITE, CPS_ZONE_TARIFAIRE, CPS_ZONE_IK,
            CPS_HABILITATION_FSE, CPS_HABILITATION_LOT,
        };
    },
    computed: {
        situations() { return listeSituations(this.cps); },
        situationActive() { return this.situations[this.indexSel] || null; },
        nomPorteur() {
            const p = porteur(this.cps);
            return p ? champ(p, CPS_NOM).replace(/[0-9]/g, '').trim() : '';
        },
    },
    watch: {
        // Reinitialise la selection a chaque ouverture.
        modelValue(v) { if (v) this.indexSel = 0; },
    },
    methods: {
        c(bloc, i) { return champ(bloc, i); },
        libelle(s) { return libelleSituation(s, this.nomPorteur); },
        valider() {
            if (this.indexSel < 0) return;
            this.$emit('choisir', this.indexSel + 1); // 1-based
            this.$emit('update:modelValue', false);
        },
        annuler() {
            this.$emit('annuler');
            this.$emit('update:modelValue', false);
        },
    },
};
</script>

<style scoped>
.liste-situations { max-height: 220px; overflow-y: auto; }
.detail-situation > div { margin: 2px 0; font-size: 0.9rem; }
</style>
